import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { TEvent as Event } from '../types';
import { useToast } from '@/components/ui/use-toast';
import { label } from '@/utils/label';
import { LabelGroup } from '@/features/label/types';

const QUERY_KEY = 'events';

export const copyEvent = (eventId: number): Promise<Event> => {
  return axios.post(`/event/copy/${eventId}`);
};

type UseCreateEventOptions = {
  organizerId: number;
  config?: MutationConfig<typeof copyEvent>;
};

export const useCopyEvent = ({ config = {}, organizerId }: UseCreateEventOptions) => {
  const { toast } = useToast();

  return useMutation({
    onMutate: async (_) => {
      await queryClient.cancelQueries([QUERY_KEY, organizerId]);

      const previousEvents = queryClient.getQueryData<Event[]>([QUERY_KEY, organizerId]);

      return { previousEvents };
    },
    onError: (_, __, ___: any) => {
      toast({
        variant: 'destructive',
        title: label('something_went_wrong', LabelGroup.GLOBAL),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY, organizerId]);
      queryClient.refetchQueries([QUERY_KEY, organizerId]);

      toast({
        variant: 'success',
        title: label('event_copied_successfully', LabelGroup.ORGANIZER_EVENT_LIST),
      });
    },
    ...config,
    mutationFn: (eventId: any) => copyEvent(eventId),
  });
};
